import "core-js/modules/es.array.sort.js";

/**
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').SafeOptions} SafeOptions
 */
import { patternCompile } from './pattern-compile.js';
import { patternInScope } from './pattern-in-scope.js';
/**
 * @param {Context} context
 * @param {string|null|undefined} input
 * @param {SafeOptions & {encode?: Array<string>}} config
 * @returns {string}
 */

export function safe(context, input, config) {
  var value = (config.before || '') + (input || '') + (config.after || '');
  /** @type {Array<number>} */

  var positions = [];
  /** @type {Array<string>} */

  var result = [];
  /** @type {Record<number, {before: boolean, after: boolean}>} */

  var infos = {};
  var index = -1;

  while (++index < context.unsafe.length) {
    var pattern = context.unsafe[index];

    if (!patternInScope(context.stack, pattern)) {
      continue;
    }

    var expression = patternCompile(pattern);
    /** @type {RegExpExecArray|null} */

    var match = void 0;

    while (match = expression.exec(value)) {
      var before = 'before' in pattern || Boolean(pattern.atBreak);
      var after = ('after' in pattern);
      var position = match.index + (before ? match[1].length : 0);

      if (positions.includes(position)) {
        if (infos[position].before && !before) {
          infos[position].before = false;
        }

        if (infos[position].after && !after) {
          infos[position].after = false;
        }
      } else {
        positions.push(position);
        infos[position] = {
          before: before,
          after: after
        };
      }
    }
  }

  positions.sort(numerical);
  var start = config.before ? config.before.length : 0;
  var end = value.length - (config.after ? config.after.length : 0);
  index = -1;

  while (++index < positions.length) {
    var _position = positions[index]; // Character before or after matched:

    if (_position < start || _position >= end) {
      continue;
    } // If this character is supposed to be escaped because it has a condition on
    // the next character, and the next character is definitly being escaped,
    // then skip this escape.


    if (_position + 1 < end && positions[index + 1] === _position + 1 && infos[_position].after && !infos[_position + 1].before && !infos[_position + 1].after || positions[index - 1] === _position - 1 && infos[_position].before && !infos[_position - 1].before && !infos[_position - 1].after) {
      continue;
    }

    if (start !== _position) {
      // If we have to use a character reference, an ampersand would be more
      // correct, but as backslashes only care about punctuation, either will
      // do the trick
      result.push(escapeBackslashes(value.slice(start, _position), '\\'));
    }

    start = _position;

    if (/[!-/:-@[-`{-~]/.test(value.charAt(_position)) && (!config.encode || !config.encode.includes(value.charAt(_position)))) {
      // Character escape.
      result.push('\\');
    } else {
      // Character reference.
      result.push('&#x' + value.charCodeAt(_position).toString(16).toUpperCase() + ';');
      start++;
    }
  }

  result.push(escapeBackslashes(value.slice(start, end), config.after));
  return result.join('');
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */

function numerical(a, b) {
  return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */


function escapeBackslashes(value, after) {
  var expression = /\\(?=[!-/:-@[-`{-~])/g;
  /** @type {Array<number>} */

  var positions = [];
  /** @type {Array<string>} */

  var results = [];
  var whole = value + after;
  var index = -1;
  var start = 0;
  /** @type {RegExpExecArray|null} */

  var match;

  while (match = expression.exec(whole)) {
    positions.push(match.index);
  }

  while (++index < positions.length) {
    if (start !== positions[index]) {
      results.push(value.slice(start, positions[index]));
    }

    results.push('\\');
    start = positions[index];
  }

  results.push(value.slice(start));
  return results.join('');
}